import { Directive, Input, OnInit, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserRoleService } from '../services/role.service';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[appHasRole]'
})
export class HasRoleDirective implements OnInit, OnDestroy {
    @Input('appHasRole') allowedRoles: string[] = [];
    private hasView = false;
    private subscription: Subscription | null = null;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private userRoleService: UserRoleService
    ) { }

    ngOnInit() {
        this.subscription = this.userRoleService.getUserRole().subscribe(role => {
            
            if (!role || role === 'none') {
                this.viewContainer.clear();
                this.hasView = false;
                return;
            }

            const userRole = role.toLowerCase();
            
            const hasRole = this.allowedRoles.some(allowedRole => 
                allowedRole.toLowerCase() === userRole
            );

            if (hasRole && !this.hasView) {
                this.viewContainer.createEmbeddedView(this.templateRef);
                this.hasView = true;
            } else if (!hasRole && this.hasView) {
                this.viewContainer.clear();
                this.hasView = false;
            }
        });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}